export interface ValidationResult {
	isValid: boolean;
	errors: string[];
}

export interface NameValidationResult {
	isValid: boolean;
	error?: string;
}

export const validatePassword = (password: string): ValidationResult => {
	const errors: string[] = [];

	if (password.length < 6) {
		errors.push('A senha deve ter no mínimo 6 caracteres');
	}
	if (password.length > 48) {
		errors.push('A senha deve ter no máximo 48 caracteres');
	}
	if (!/[a-z]/.test(password)) {
		errors.push('A senha deve conter pelo menos uma letra minúscula');
	}
	if (!/[A-Z]/.test(password)) {
		errors.push('A senha deve conter pelo menos uma letra maiúscula');
	}
	if (!/\d/.test(password)) {
		errors.push('A senha deve conter pelo menos um número');
	}
	if (/\s/.test(password)) {
		errors.push('A senha não pode conter espaços');
	}

	return {
		isValid: errors.length === 0,
		errors,
	};
};

export const validateName = (name: string): NameValidationResult => {
	const nameRegex = /^[a-zA-ZÀ-ÿ'\s-]+$/;

	if (!name.trim()) {
		return { isValid: false, error: 'O nome é obrigatório' };
	}

	if (!nameRegex.test(name)) {
		return {
			isValid: false,
			error: 'O nome deve conter apenas letras, acentos, hífens e apóstrofos',
		};
	}

	return { isValid: true };
};

export const validateEmail = (email: string): NameValidationResult => {
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	if (!email.trim()) {
		return { isValid: false, error: 'O email é obrigatório' };
	}

	if (!emailRegex.test(email)) {
		return { isValid: false, error: 'Email inválido' };
	}

	return { isValid: true };
};

export const validatePasswordMatch = (
	password: string,
	confirmPassword: string
): NameValidationResult => {
	if (password !== confirmPassword) {
		return { isValid: false, error: 'As senhas não coincidem' };
	}

	return { isValid: true };
};

export const validateTermsAcceptance = (accepted: boolean): NameValidationResult => {
	if (!accepted) {
		return {
			isValid: false,
			error: 'Você deve aceitar os termos e políticas de privacidade',
		};
	}

	return { isValid: true };
};
